module.exports = __webpack_public_path__ + "img/carrousel-flatpanel-4.9dac874b.png";